const Container = ({ className, children, cutomPadding }) => {
  return (
    <div
      className={`container mx-auto ${cutomPadding ? cutomPadding : 'px-4 py-2'} ${className || ''}`}
    >
      {children}
    </div>
  );
};

export default Container;
